import { snakeCase } from 'lodash';

// ['fooBar'] => { fooBar: 'FOO_BAR' }
export default (keys, transformer = key => snakeCase(key).toUpperCase()) =>
  keys.reduce((acc, key) => ({ ...acc, [key]: transformer(key) }), {});



// WEBPACK FOOTER //
// ./src/utils/buildEnum.js